<div class="w-full h-full flex justify-center">
  <div class="grid grid-cols-9 grid-rows-2 gap-2 p-2 w-full h-full flex justify-center">
    @for (color of colors; track color) {
      <div class = "flex justify-center items-center">
        <p-badge [style.background-color]="color" [class]="{'selectedColor':color==selectedColor,'clickable':true}" size="large" (click)="selectColor(color)"></p-badge>
      </div>
    }
  </div>
</div>
